import * as C from "./styles";

export const Header = () => {
  return (
    <C.Container>
      <h1>Cadastro de Desenvolvedor</h1>
      <p>Faça seu cadastro na lista e receba um emprego instantaneamente. </p>
    </C.Container>
  );
};
